module.exports = __webpack_public_path__ + "static/img/u305.51d2382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u305.png
// module id = ZfBu
// module chunks = 1